import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { URL } from "../../Redux/common/url";

function LodingImg({ i, data }) {
  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <div className="position-relative" >
      <img
        src={URL.API_BASE_URL + data?.image}
        alt={"slider" + i}
        className={` blur-image ${isLoaded ? "hide" : ""}`}
        style={{
          filter: "blur(10px)",
          transition: "opacity 0.3s ease-in-out",
          opacity: isLoaded ? 0 : 1,
        }}
      />
      <LazyLoadImage
        alt={"slider" + i}
        // width={imageWidth}
        // height={imageHeight}
        // className="rounded-circle"
        delayTime={300}
        onLoad={() => setIsLoaded(true)}
        style={{
          transition: "opacity 0.3s ease-in-out",
          opacity: isLoaded ? 1 : 0,
        }}
        src={URL?.API_BASE_URL + data?.image} // use normal <img> attributes as props
      />
    </div>
  );
}

export default LodingImg;
